import type { ReactNode } from "react"
import { useConsent } from "./useConsent"

/**
 * Renders children only once consent is known on the client and performance
 * cookies are allowed. Wrap non-essential third-party tags in this — nothing
 * inside it reaches the server-rendered HTML, so a rejecting visitor never
 * loads the tag at all.
 */
export function PerformanceConsentGate({ children }: { children: ReactNode }) {
  const { isResolved, isPerformanceAllowed } = useConsent()

  if (!isResolved || !isPerformanceAllowed) {
    return null
  }

  return <>{children}</>
}
